import { BrowserRouter, Route } from "react-router-dom";
import {useState } from "react";
import "./styles/App.css";
import Header from "./components/Header";
import data from "./models/data.json";
import ProductList from "./components/ProductList";
import Basket from "./components/Basket";
import About from "./pages/About";
import Search from "./components/Search";
import Pagination from "./components/Pagination";
import React from "react";

function App() {
  const [items, setItems] = useState(data);
  const [basket, setBasket] = useState([]);
  const [term, setTerm] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const itemsPerPage = 30
  const [searching, setSearching] = useState(false);
  const basketIds = basket.map((item) => item.trackId);
  const count = basket.length;
  const basketTotal =
    count > 0
      ? Math.round(
          (basket
            .map((item) => (item.trackPrice ? item.trackPrice : 0))
            .reduce(
              (previousValue, currentValue) => previousValue + currentValue
            ) +
            Number.EPSILON) *
            100
        ) / 100
      : 0;

  const addToBasket = (trackId) => {
    setBasket(basket.concat(items.filter((item) => item.trackId === trackId)));
    setItems([
      ...items.map((item) => {
        if (item.trackId === trackId) {
          item.inBasket = true;
        }
        return item;
      }),
    ]);
  };
  const removeFromBasket = (trackId) => {
    setBasket(basket.filter((item) => item.trackId !== trackId));
    setItems([
      ...items.map((item) => {
        if (item.trackId === trackId) {
          item.inBasket = false;
        }
        return item;
      }),
    ]);
  };

  async function search(term) {
    const url = `https://itunes.apple.com/search?term=${term}&limit=200&explicit=no`;
    const results = await fetch(url).then((res) => res.json());
    if (!results.error) {
      setItems(
        results.results.filter((item) => !basketIds.includes(item.trackId))
      );
      setSearching(true);
    }
  }

  //get current items
  const lastItemIndex = pageNumber * itemsPerPage;
  const firstItemIndex = lastItemIndex - itemsPerPage;
  const currentItems = items.slice(firstItemIndex, lastItemIndex);

  //change page
  const paginate = (pageNumber) => {
    setPageNumber(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetList = () => {
    setItems(data.filter((item) => !basketIds.includes(item.trackId)));
    setSearching(false);
    setPageNumber(1);
  };

  return (
    <div className="container">
      <BrowserRouter>
        <Route
          exact
          path="/"
          render={() => (
            <>
              <Header
                basket={basket}
                basketCount={count}
                resetList={resetList}
              />
              <Search search={search} setTerm={setTerm} term={term} />
              <div id="results">
                <ProductList
                  items={currentItems}
                  addToBasket={addToBasket}
                  removeFromBasket={removeFromBasket}
                  itemCount={items.length}
                  searching={searching}
                  resetList={resetList}
                  totalItems={items.length}
                  firstItemIndex={firstItemIndex}
                  pageNumber={pageNumber}
                />
                <Pagination
                  itemsPerPage={itemsPerPage}
                  totalItems={items.length}
                  paginate={paginate}
                />
              </div>
            </>
          )}
        />
        <Route
          exact
          path="/about"
          render={() => <About basketCount={count} resetList={resetList} />}
        />
        <Route
          exact
          path="/basket"
          render={() => (
            <>
              <Header basketCount={count} resetList={resetList} />
              <Basket
                basket={basket}
                removeFromBasket={removeFromBasket}
                basketTotal={basketTotal}
                basketCount={count}
              />
            </>
          )}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;